// extracted by mini-css-extract-plugin
export default {"slider":"Emision_slider__UZszd"};